import { useEffect, useState } from 'react';
import { uniqueChannelName } from '../../lib/realtime';
import { supabase } from '../../lib/supabase';

export interface QueueBreakerState {
  /** null while loading */
  isOn: boolean | null;
  /** When the breaker last flipped — marks the start of the current session. */
  changedAt: string | null;
}

/** Live queue breaker state (single row, id = 1). */
export default function useQueueBreaker(): QueueBreakerState {
  const [state, setState] = useState<QueueBreakerState>({ isOn: null, changedAt: null });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data, error } = await supabase
          .from('queue_breaker')
          .select('is_on, updated_at')
          .eq('id', 1)
          .maybeSingle();
        if (error) throw error;
        if (!cancelled) {
          setState({
            isOn: Boolean(data?.is_on),
            changedAt: (data?.updated_at as string | undefined) ?? null,
          });
        }
      } catch (err) {
        console.error('Error loading queue breaker state:', err);
      }
    };
    load();
    const channel = supabase
      .channel(uniqueChannelName('queue_breaker_state'))
      .on('postgres_changes', { event: '*', schema: 'public', table: 'queue_breaker' }, load)
      .subscribe();
    return () => {
      cancelled = true;
      supabase.removeChannel(channel);
    };
  }, []);

  return state;
}
